import { createContext } from 'react';

// These contexts live in their own module — separate from App.jsx, which also
// exports the App component — so their identity stays stable across Vite Fast
// Refresh. When createContext was called inside App.jsx, editing App.jsx (or a
// module in its refresh boundary) re-ran createContext and minted a NEW context
// object. The re-rendered Provider used the new object while already-mounted
// consumers still referenced the old one, so useContext returned the null
// default and destructuring it crashed — but only on localhost, where Fast
// Refresh runs. Defining them here means createContext runs exactly once.

export const UserProfileContext = createContext(null);
export const ThemeContext = createContext(null);
